import { Button } from '@bennows/boows-react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../lib/api';

/**
 * First end-to-end slice through the generated client (AC-05-023): the API
 * version from `GET /healthz`. Failure is a non-blocking banner with retry.
 */
export function VersionIndicator() {
  const { t } = useTranslation();
  const health = useQuery({
    queryKey: ['operations', 'liveness'],
    queryFn: async () => {
      const { data, error } = await api.GET('/healthz');
      if (error || !data) throw new Error('healthz failed');
      return data;
    },
    retry: false,
  });

  if (health.isError) {
    return (
      <div className="ui-error-state" role="alert">
        <p className="ui-error-state__text">{t('version.unreachable')}</p>
        <Button variant="ghost" size="sm" onClick={() => void health.refetch()}>
          {t('error.retry')}
        </Button>
      </div>
    );
  }
  // One persistent live region, so the change from loading to the version is announced.
  return (
    <span role="status">
      {health.isPending ? (
        <>
          <span className="ui-visually-hidden">{t('version.loading')}</span>
          <span className="ui-skeleton ui-skeleton--text" aria-hidden="true" />
        </>
      ) : (
        t('version.label', { version: health.data.version })
      )}
    </span>
  );
}
